<div flex fxLayout="row" class="row">
  <div fxFlex="40" class="pt-3">
    <h1>Jugadores</h1>
  </div>
  <div fxFlex="40" class="pt-4">
    <mat-form-field class="w-100">
      <input matInput placeholder="Buscar por Nombre, Teléfono o Email" #searchInput>
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
  <div fxFlex="20" class="text-right filter-buttons pt-4">
    <mat-button-toggle-group name="filterTipo" #group="matButtonToggleGroup" value="all">
      <mat-button-toggle value="all" aria-label="Todos">Todos</mat-button-toggle>
      <mat-button-toggle value="org">Organizadores</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>

<div class="mat-elevation-z8">
  <div class="spinner-container text-center" *ngIf="dataSource.loading$ | async">
    <mat-spinner diameter="30"></mat-spinner>
  </div>

  <table mat-table [dataSource]="dataSource" class="table" matSort matSortActive="id" matSortDirection="asc"
    matSortDisableClear>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="id"> ID </th>
      <td width="50" mat-cell *matCellDef="let element"> {{element.id}} </td>
    </ng-container>
    <ng-container matColumnDef="nombre">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="username"> Nombre </th>
      <td mat-cell *matCellDef="let element"><a [routerLink]="['/players', element.id]">{{element.username}}</a>
      </td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th width="300" mat-header-cell *matHeaderCellDef mat-sort-header="email"> Email </th>
      <td mat-cell *matCellDef="let element"> {{ element.email }} </td>
    </ng-container>
    <ng-container matColumnDef="phone">
      <th width="300" mat-header-cell *matHeaderCellDef> Teléfono </th>
      <td mat-cell *matCellDef="let element"><span
          *ngFor="let phone of element.player_phones; let first = first; let last = last">{{ phone.phone }}<span
            *ngIf="!last">, </span></span></td>
    </ng-container>
    <ng-container matColumnDef="reservas">
      <th width="100" mat-header-cell *matHeaderCellDef> Reservas </th>
      <td mat-cell *matCellDef="let element"> {{ element.reservas }} </td>
    </ng-container>
    <ng-container matColumnDef="partidos">
      <th width="100" mat-header-cell *matHeaderCellDef> Partidos </th>
      <td mat-cell *matCellDef="let element"> {{ element.partidos }} </td>
    </ng-container>
    <ng-container matColumnDef="more">
      <th width="30" mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element" width="20"><i class="material-icons">more_vert</i></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

  <mat-paginator [length]="dataSource.total" [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons>
  </mat-paginator>

</div>